'use strict';


import { Exposure } from './QAExposure';
import { getUrlParam } from '../../functions';
import * as dat from 'dat.gui';
import { PoiQA } from './QAPoi';
import { QAPublicLayers } from './QAPublicLayers';
import { VantagesQA } from './QAVantages';
import { ObjectsQA } from './QAObjects';
import { QAApartmentsPlan } from './QAApartmentsPlan';
import { QARotor } from './QARotor';
import { QAKeyPlan } from './QAKeyPlan';
import { QAAirMode } from './QAAirMode';

export class QA {
	static active = getUrlParam('mode') === 'qa';
	
	constructor () {
		this.tests = {};
		this.gui = null
	}
	
	init() {
		if (!QA.active)
			return this;
		
		this.tests.Exposure = new Exposure();
		this.tests.Poi = new PoiQA();
		this.tests.PublicLayers = new QAPublicLayers();
		if (config.features.vantage?.type === 'photographic') {
			config.features.hideKeyPlanButton = false;
			config.features.cylinderDisplayMode = {mode: 'show all'};
			this.tests.Vantages = new VantagesQA();
		}
		this.tests.Viewpoints = new ObjectsQA();
		this.tests.Plans2D = new QAApartmentsPlan();
		this.tests.Rotor = new QARotor();
		this.tests.KeyPlan = new QAKeyPlan();
		this.tests.AirMode = new QAAirMode();
		
		this.gui = new dat.GUI();
		Object.entries(this.tests).forEach(([key,scope]) => {
			this.gui.add({[key]:() => scope.validate()},key);
		});
		
		return this;
	}
}




